import { validateModel, checkValue } from 'models/validate';
import usPassport from 'forms/sections/citizenship/usPassports/validate';

export const validateUsPassport = (data, formType, options = {}) => validateModel(data, usPassport, options);

export const hasValidUSPassport = (data = {}) => {
  const { HasPassports = {} } = data;
  return checkValue(HasPassports, 'Yes') && validateUsPassport(data) === true;
};

export const isForeignBornUSCitizen = (data = {}) => data.Citizenship?.Status?.CitizenshipStatus?.value === 'Naturalized';
